import { useQuery } from '@apollo/client'
import { GET_TRANSACTION_FEES } from './queries'
import { TransactionFee } from './types'

type Response = [
  TransactionFee,
  {
    loading: boolean
    refetch: () => Promise<any>
    error?: any
  }
]

const useGetTransactionFee = ({
  transactionPlanId
}: {
  transactionPlanId: string | null
}): Response => {
  const { data, loading, refetch, error } = useQuery(GET_TRANSACTION_FEES, {
    variables: {
      transactionPlanId
    },
    fetchPolicy: 'no-cache',
    skip: !transactionPlanId
  })

  const transactionFee = data?.transaction_plans?.[0] || null

  return [transactionFee, { loading, refetch, error }]
}

export default useGetTransactionFee
